<template>
  <div>
    <header class="section pricing-header">
      <div class="container">
        <div class="columns header is-vcentered is-hidden-mobile">
          <div class="column">
            <h1 class="title is-1 is-spaced">{{ info.title }}</h1>
            <p class="subtitle has-text-weight-medium">
              {{ info.desc }}
            </p>
          </div>
          <div class="column">
            <template v-if="info && info.video_url">
              <div class="image is-16by9">
                <div class="iframe-wrap" v-html="info.video_url"></div>
              </div>
            </template>
            <template v-else-if="info.image">
              <div class="image">
                <img alt="..." :src="info.image" />
              </div>
            </template>
          </div>
        </div>
        <div class="columns header is-hidden-tablet">
          <div class="column">
            <h1 class="title is-1 is-spaced">Play Passes &amp; Party</h1>
            <p class="subtitle has-text-weight-medium">
              {{ info.desc }}
            </p>
          </div>
        </div>
      </div>
    </header>
    <div v-for="(item, index) in items" :key="index">
      <section class="section who" v-if="index % 2 == 0">
        <div class="container py-4">
          <div class="columns is-desktop is-vcentered">
            <div class="column is-hidden-desktop">
              <figure class="image is-5by3">
                <img v-if="item.image" :src="item.image" />
              </figure>
            </div>
            <div class="column is-6-desktop-only">
              <h2 class="title is-spaced">{{ item.title }}</h2>
              <p class="subtitle has-text-justified has-text-grey-darker">
                {{ item.desc }}
              </p>
              <div class="is-hidden-mobile is-hidden-touch">
                <div
                  v-for="(citem, index) in shopList"
                  :key="`${index}${item.path}`"
                >
                  <!-- :class="index == 0 ? 'mb-2' : ''" -->
                  <!-- :class="index == 0 ? '' : 'mt-2'" -->
                  <a
                    v-for="(ditem, dindex) in citem"
                    :key="dindex"
                    :href="`https://${ditem.domain}${item.path}`"
                    class="tag is-primary is-large is-rounded has-text-weight-semibold mb-2"
                    :style="{
                      marginRight: dindex != citem.length - 1 ? '4px' : '',
                    }"
                  >
                    <img
                      class="fas fa-map-marker-alt mr-2 local-img"
                      src="../../assets/img/local.png"
                    />
                    {{ ditem.name }}
                  </a>
                </div>
              </div>
              <div class="is-hidden-desktop">
                <div
                  v-for="(citem, index) in shopListMobile"
                  :key="`${index}${item.path}`"
                  :class="index == 0 ? '' : 'mt-2'"
                >
                  <a
                    :href="`https://${citem.domain}${item.path}`"
                    class="tag is-primary is-large is-rounded has-text-weight-semibold"
                  >
                    <i class="fas fa-map-marker-alt has-text-white mr-2"></i>
                    {{ citem.name }}
                  </a>
                </div>
              </div>
            </div>
            <div class="column is-hidden-touch">
              <figure class="image is-5by3">
                <img v-if="item.image" :src="item.image" />
              </figure>
            </div>
          </div>
        </div>
      </section>
      <section class="section believe" v-if="index % 2 != 0">
        <div class="container py-4">
          <div class="columns is-desktop is-vcentered">
            <div class="column has-text-right">
              <figure class="image player is-16by9">
                <img v-if="item.image" :src="item.image" />
              </figure>
            </div>
            <div class="column is-6-desktop-only">
              <h2 class="title is-spaced">{{ item.title }}</h2>
              <p class="subtitle has-text-justified has-text-grey-darker">
                {{ item.desc }}
              </p>
              <div class="is-hidden-mobile is-hidden-touch">
                <div
                  v-for="(citem, index) in shopList"
                  :key="`${index}${item.path}`"
                >
                  <!-- :class="index == 0 ? '' : 'mt-2'" -->
                  <a
                    v-for="(ditem, dindex) in citem"
                    :key="dindex"
                    :href="`https://${ditem.domain}${item.path}`"
                    class="tag is-primary is-large is-rounded has-text-weight-semibold mb-2"
                    :style="{
                      marginRight: dindex != citem.length - 1 ? '4px' : '',
                    }"
                  >
                    <img
                      class="fas fa-map-marker-alt mr-2 local-img"
                      src="../../assets/img/local.png"
                    />
                    {{ ditem.name }}
                  </a>
                </div>
              </div>
              <div class="is-hidden-desktop">
                <div
                  v-for="(citem, index) in shopListMobile"
                  :key="`${index}${item.path}`"
                  :class="index == 0 ? '' : 'mt-2'"
                >
                  <a
                    :href="`https://${citem.domain}${item.path}`"
                    class="tag is-primary is-large is-rounded has-text-weight-semibold"
                  >
                    <i class="fas fa-map-marker-alt has-text-white mr-2"></i>
                    {{ citem.name }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import { pricingConfig } from "@/server/api.js";
import store from "@/store";

export default {
  components: {},
  data() {
    return {
      items: [],
      info: {},
    };
  },
  computed: {
    shopList() {
      var data = store.state.global.shopLists;
      var result = [];
      for (var i = 0; i < data.length; i += 2) {
        result.push(data.slice(i, i + 2));
      }
      return result;
      // return store.state.global.shopLists || [];
    },
    shopListMobile() {
      return store.state.global.shopLists || [];
    },
  },
  created() {
    this.getInfo();
  },
  methods: {
    async getInfo() {
      try {
        const { status, data } = await pricingConfig({});
        if (status == 0) {
          this.items = data.items;
          this.info = data.info;
          setTimeout(() => {
            var iframe = document.getElementsByTagName("iframe");
            for (let i = 0; i <= iframe.length - 1; i++) {
              iframe[i].style.width = "100%";
              iframe[i].style.height = "100%";
            }
          }, 0);
        }
      } catch (error) {}
    },
  },
};
</script>
<style scoped>
.pricing-header {
  background-color: #f5d784;
  margin: 0 auto;
  margin-top: 50px;
}
.columns {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
  margin-top: -1.5rem;
}
.columns.is-vcentered {
  align-items: center;
}
.columns:not(:last-child) {
  margin-bottom: 0rem;
}
.column {
  display: block;
  flex-basis: 0;
  flex-grow: 1;
  flex-shrink: 1;
  padding: 1.5rem;
}
.image {
  display: block;
  position: relative;
  height: 340px;
}
.image img {
  display: block;
  height: 100%;
}
.title.is-1 {
  font-size: 3rem;
}
.tabs:not(:last-child),
.pagination:not(:last-child),
.message:not(:last-child),
.level:not(:last-child),
.breadcrumb:not(:last-child),
.block:not(:last-child),
.title:not(:last-child),
.subtitle:not(:last-child),
.table-container:not(:last-child),
.table:not(:last-child),
.progress:not(:last-child),
.notification:not(:last-child),
.content:not(:last-child),
.box:not(:last-child) {
  margin-bottom: 1.5rem;
}

.title {
  color: #363636;
  font-family: Rubik, sans-serif;
  font-size: 2rem;
  font-weight: 600;
  line-height: 1.125;
}
.title,
.subtitle {
  word-break: break-word;
}
.has-text-weight-medium {
  font-weight: 500 !important;
}
.image {
  display: block;
  position: relative;
}
.image img {
  display: block;
  height: auto;
  width: 100%;
  max-width: 100%;
  max-height: 100%;
}
.columns:last-child {
  margin-bottom: -1.5rem;
}
.section {
  padding: 3rem 1.5rem;
}

.has-text-centered {
  text-align: center !important;
}

.py-5 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}
.tag:not(body).is-rounded {
  border-radius: 9999px;
}
.tag:not(body).is-large {
  font-size: 1.25rem;
}
.tag:not(body).is-primary {
  background-color: #de4c50;
  color: #fff;
}
.tag:not(body) {
  align-items: center;
  background-color: #f5f5f5;
  border-radius: 4px;
  color: #757763;
  display: inline-flex;
  font-size: 0.75rem;
  height: 2em;
  justify-content: center;
  line-height: 1.5;
  padding-left: 0.75em;
  padding-right: 0.75em;
  white-space: nowrap;
}
.has-text-weight-semibold {
  font-weight: 600 !important;
}
.mr-2 {
  margin-right: 0.5rem !important;
}
.has-text-white {
  color: #fff !important;
}
.fas,
.fa-solid {
  font-weight: 900;
}
.mt-5 {
  margin-top: 1.5rem !important;
}
.subtitle {
  color: #757763;
  font-family: Quicksand, sans-serif;
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 1.25;
}
.mt-2 {
  margin-top: 0.5rem !important;
}
.mb-2 {
  margin-bottom: 0.5rem !important;
}
.has-text-grey-darker {
  color: #363636 !important;
}
@media screen and (max-width: 768px) {
  .is-hidden-mobile {
    display: none !important;
  }
}
@media screen and (min-width: 769px) {
  .columns:not(.is-desktop) {
    display: flex;
  }
  .is-hidden-tablet {
    display: none !important;
  }
}
@media screen and (max-width: 1023px) {
  .is-hidden-touch {
    display: none !important;
  }
}

@media screen and (min-width: 1024px) {
  .container {
    max-width: 960px;
  }
  .is-hidden-desktop {
    display: none !important;
  }
  .columns.is-desktop {
    display: flex;
  }
  .section {
    padding: 3rem;
  }
}
@media screen and (min-width: 1408px) {
  .container {
    max-width: 1344px;
  }
}
.local-img {
  max-width: 20px;
}
.iframe-wrap {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/pricing/index.vue